import { render, staticRenderFns } from "./WelfareCollectionActivity.vue?vue&type=template&id=066afe46&scoped=true"
import script from "./WelfareCollectionActivity.vue?vue&type=script&lang=js"
export * from "./WelfareCollectionActivity.vue?vue&type=script&lang=js"
import style0 from "./WelfareCollectionActivity.vue?vue&type=style&index=0&id=066afe46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066afe46",
  null
  
)

export default component.exports